import React from "react";
import { Link } from "react-router-dom";

const FormsTable = ({ forms, onRowClick, isCompact = false }) => {
   const formatFormType = (type) =>
      type ? type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()) : "";

   if (!forms || forms.length === 0) {
      return (
         <div className="empty-state compact-empty">
            <i className="bi bi-inbox"></i>
            <h5>No Forms Found</h5>
         </div>
      );
   }

   return (
      <div className="table-responsive">
         <table className={`forms-table ${isCompact ? "data-table" : ""}`}>
            <thead>
               <tr>
                  <th>Type</th>
                  <th>Conversation {isCompact ? "ID" : ""}</th>
                  <th>Date</th>
                  {!isCompact && <th>Error Status</th>}
                  <th>Actions</th>
               </tr>
            </thead>
            <tbody>
               {forms.map((form, index) => {
                  const hasErrors = form.error_count > 0;
                  return (
                     <tr
                        key={form.id || index}
                        onClick={() => {
                           console.log("Row clicked:", form);
                           onRowClick && onRowClick(form);
                        }}
                        className={`forms-table-row ${hasErrors ? "row-error" : ""}`}
                        style={{ cursor: onRowClick ? "pointer" : "default" }}
                     >
                        <td>
                           <span
                              className={`pill pill-type ${
                                 form.form_type === "driver_verification"
                                    ? "pill-blue"
                                    : "pill-purple"
                              }`}
                           >
                              {formatFormType(form.form_type)}
                           </span>
                        </td>
                        <td className={hasErrors ? "text-danger-emphasis" : "text-muted"}>
                           {form.conversation_id}
                           {hasErrors && (
                              <i
                                 className="bi bi-exclamation-circle ms-1 text-danger"
                                 title="Has error reports"
                              ></i>
                           )}
                        </td>
                        <td className={hasErrors ? "text-danger-emphasis" : "text-muted"}>
                           {form.formatted_date}
                        </td>
                        {!isCompact && (
                           <td>
                              {hasErrors ? (
                                 <span className="pill pill-error">
                                    <i className="bi bi-exclamation-triangle me-1"></i>
                                    {form.error_count} Error
                                    {form.error_count > 1 ? "s" : ""}
                                 </span>
                              ) : (
                                 <span className="pill pill-success">
                                    <i className="bi bi-check-circle me-1"></i>
                                    No Errors
                                 </span>
                              )}
                           </td>
                        )}
                        <td onClick={(e) => e.stopPropagation()}>
                           <div className="table-actions">
                              {hasErrors ? (
                                 <Link
                                    to={`/forms/${form.id}/errors`}
                                    className="pill-btn pill-btn-red"
                                    title="View Error Reports"
                                 >
                                    View Error Report
                                 </Link>
                              ) : (
                                 <Link
                                    to={`/forms/report/${form.id}?form_type=${form.form_type}`}
                                    className="pill-btn pill-btn-yellow"
                                    title="Report Error"
                                 >
                                    Report Error
                                 </Link>
                              )}
                           </div>
                        </td>
                     </tr>
                  );
               })}
            </tbody>
         </table>
      </div>
   );
};

export default FormsTable;
